import BillingStatus from '../constants/billing-status';
import { colors } from 'constants/colors';
export function getBillingStatusBadgeColor(billingStatus) {
    switch (billingStatus) {
        case BillingStatus.AWAITING_BILLABLE_EVENT:
            return 'gray';
        case BillingStatus.READY_TO_BILL:
            return 'blue';
        case BillingStatus.INCOMPLETE:
        case BillingStatus.BILLING_HOLD:
            return 'red';
        case BillingStatus.AUDITED:
        case BillingStatus.INVOICED:
            return 'green';
        default:
            return 'gray';
    }
}
export function getBillingStatus(billingStatus) {
    switch (billingStatus) {
        case BillingStatus.AWAITING_BILLABLE_EVENT:
            return 'AWAITING_BILLABLE_EVENT';
        case BillingStatus.READY_TO_BILL:
            return 'READY_TO_BILL';
        case BillingStatus.INCOMPLETE:
            return 'INCOMPLETE';
        case BillingStatus.AUDITED:
            return 'AUDITED';
        case BillingStatus.INVOICED:
            return 'INVOICED';
        case BillingStatus.SUPPLEMENTAL_INVOICE:
            return 'SUPPLEMENTAL_INVOICE';
        case BillingStatus.TEMPLATE_BILLING:
            return 'TEMPLATE_BILLING';
        case BillingStatus.CUSTOMER_PORTAL:
            return 'CUSTOMER_PORTAL';
        default:
    }
}
export const getOverrideBillingStatusBadgeColor = (status) => {
    switch (status) {
        case 'hold':
            return colors.orange;
        case 'canceled':
            return colors.red;
        default:
            return colors.gray;
    }
};
export const getOrderStatusBadgeColor = (status) => {
    switch (status) {
        case 'complete':
            return colors.green;
        case 'en_route':
            return colors.blue;
        case 'booked':
            return colors.indigo;
        case 'booking':
            return colors.yellow;
        case 'canceled':
            return colors.pink;
        case 'arrived':
            return colors.orange;
        case 'created':
            return colors.purple;
        default:
            return colors.gray;
    }
};
